// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__ogUTY","body":"style__body__f9QFa","header":"style__header__LfR34","footer":"style__footer__At-GH"};